module.exports = __webpack_public_path__ + "img/bth_bed2_right_tunbu_sel.3adbd147.png";